import categories from "./it/categories.json";
import error from "./it/error.json";
import items from "./it/items.json";
import lang from "./it/lang.json";
import layout from "./it/layout.json";
import live from "./it/live.json";
import loki from "./it/loki.json";
import media from "./it/media.json";
import online from "./it/online.json";
import organization from "./it/organization.json";
import payouts from "./it/payouts.json";
import preferences from "./it/preferences.json";
import sales from "./it/sales.json";
import search from "./it/search.json";
import sidenav from "./it/sidenav.json";
import user from "./it/user.json";

const countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/it.json"));

export default {
    ...categories,
    ...countries.getNames("it"),
    ...error,
    ...items,
    ...lang,
    ...layout,
    ...live,
    ...loki,
    ...media,
    ...online,
    ...organization,
    ...payouts,
    ...preferences,
    ...sales,
    ...search,
    ...sidenav,
    ...user
};
